import { useEventBus } from "@vueuse/core";
const personDataEventBusKey = Symbol();
export const personDataEvent = useEventBus(personDataEventBusKey);
